import styled from "styled-components";
import { deviceQuery } from "../../../styles/mediaSizes"

export const Middle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 2rem;

  @media ${deviceQuery.mobileL} {
    padding: 0rem 1rem;
    margin-bottom: 2rem;
  }

  > p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 12px;
    font-weight: 600;
  }
`;

export const Reward = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: ${({ theme }) => theme.palette.common.text.secondary};
    font-size: 12px;
    margin: 0;
  }
`;

export const BtnWrapper = styled.div`
  margin-top: 1.25rem;
  padding: 0rem 1.5rem;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.palette.common.background};
`

export const InputRange = styled.input`
  --webkitProgressPercent: 0%;

  width: 100%;
  height: 1rem;
  outline: none;
  border: 1px solid ${({ theme }) => theme.palette.common.text.secondary + 20} !important;
  border-radius: 30px;
  /* background-color: red; */
  /*   -webkit-appearance: none;
  background: ${({ slided, theme }) => `
      linear-gradient(to right, ${theme.palette.card.text.primary} 0%, ${theme.palette.card.text.primary} ${slided}%, #fff ${slided}%, white 100%)
    `}; */

  &::-moz-focus-outer {
    border: 0;
  }
  &:hover {
    outline: none;
  }

  / Chrome / &::-webkit-slider-runnable-track {
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    cursor: pointer;
    border-radius: 50%;
    outline: none;
  }

  / Moz / &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    background: #f1f9f4;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    outline: none;
  }

  &::-moz-range-progress {
    background-color: ${({ theme }) => theme.palette.card.text.primary};
    height: 100%;
    border-radius: 30px;
    border: 1px solid ${({ theme }) => theme.palette.card.text.primary};
  }
  &::-moz-range-track {
    background-color: ${({ theme }) => theme.palette.common.background};
    border-radius: 30px;
    border: none;
    height: 100%;
  }

  /* IE*/

  &::-ms-fill-lower {
    background-color: ${({ theme }) => theme.palette.card.text.primary};
    height: 100%;
    border-radius: 30px;
    border: none;
  }
  &::-ms-fill-upper {
    background-color: ${({ theme }) => theme.palette.common.background};
    border-radius: 30px;
    border: none;
    height: 100%;
  }
`;
